import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import esCR from 'date-fns/locale/es';
registerLocale('es', esCR);

const DatePickerControl = (props) => {

    const CustomInput = ({ value, onClick, onChange }) => (
        <div className="input-group date">
            <input className="form-control" onClick={onClick} value={value} onChange={onChange} />
            <div className="input-group-append">
                <span className="input-group-text" onClick={onClick}><FontAwesomeIcon icon={faCalendarAlt} /></span>
            </div>
        </div>);

    return <DatePicker dateFormat="dd/MM/yyyy"
        locale="es"
        {...props.props}
        dropdownMode="select"
        selected={props.value}
        onChange={date => props.onChange(props.name, date)}
        customInput={<CustomInput />}
    />;
}

export default DatePickerControl;